module.exports = __webpack_public_path__ + "static/media/gps-verde.5317dc10.svg";